'use client';
var defaultProps = {};

export { defaultProps };
